import $ from 'jquery'

export const isIE8 = () => {
  return !!navigator.userAgent.match(/MSIE 8.0/)
}

export const isIE9 = () => {
  return !!navigator.userAgent.match(/MSIE 9.0/)
}

export const isIE10 = () => {
  return !!navigator.userAgent.match(/MSIE 10.0/)
}

export const isTouchDevice = () => {
  try {
    document.createEvent('TouchEvent')
    return true
  } catch (e) {
    return false
  }
}

export const getURLParameter = (paramName) => {
  var searchString = window.location.search.substring(1)
  var i
  var val
  var params = searchString.split('&')

  for (i = 0; i < params.length; i++) {
    val = params[i].split('=')
    if (val[0] === paramName) {
      return unescape(val[1])
    }
  }
  return null
}

export const getViewPort = () => {
  var e = window
  var a = 'inner'
  if (!('innerWidth' in window)) {
    a = 'client'
    e = document.documentElement || document.body
  }

  return {
    width: e[a + 'Width'],
    height: e[a + 'Height']
  }
}

export const getResponsiveBreakpoint = (size) => {
  // bootstrap responsive breakpoints
  var sizes = {
    'xs': 480, // extra small
    'sm': 768, // small
    'md': 992, // medium
    'lg': 1200 // large
  }

  return sizes[size] ? sizes[size] : 0
}

export const getUniqueID = (prefix) => {
  return prefix + '_' + Math.floor(Math.random() * (new Date()).getTime())
}

export const scrollTo = (el, offeset) => {
  el = $(el)

  var pos = (el && el.length > 0) ? el.offset().top : 0

  if (el) {
    if ($('body').hasClass('page-header-fixed')) {
      pos = pos - $('.page-header').height()
    } else if ($('body').hasClass('page-header-top-fixed')) {
      pos = pos - $('.page-header-top').height()
    } else if ($('body').hasClass('page-header-menu-fixed')) {
      pos = pos - $('.page-header-menu').height()
    }
    pos = pos + (offeset !== undefined ? offeset : -1 * el.height())
  }

  $('html,body').animate({
    scrollTop: pos
  }, 'slow')

}

export const scrollTop = () => scrollTo()

var resizeHandlers = [];
var _runResizeHandlers = function() {
    // reinitialize other subscribed elements
    for (var i = 0; i < resizeHandlers.length; i++) {
        var each = resizeHandlers[i];
        each.call();
    }
};

export const handleOnResize = () => {
    var resize
    if (isIE8) {
        var currheight
        $(window).resize(function() {
            if (currheight == document.documentElement.clientHeight) {
                return //quite event since only body resized not window.
            }
            if (resize) {
                clearTimeout(resize)
            }
            resize = setTimeout(function() {
                _runResizeHandlers()
            }, 50) // wait 50ms until window resize finishes.
            currheight = document.documentElement.clientHeight // store last body client height
        })
    } else {
        $(window).resize(function() {
            if (resize) {
                clearTimeout(resize)
            }
            resize = setTimeout(function() {
                _runResizeHandlers()
            }, 50) // wait 50ms until window resize finishes.
        })
    }
}
export const addResizeHandler = (func) => {
    resizeHandlers.push(func);
}

export const getDateDiff = (dateStr) => {
  var minute = 1000 * 60
  var hour = minute * 60
  var day = hour * 24
  var month = day * 30
  var now = new Date().getTime()
  var diffValue = now - Date.parse(dateStr.replace(/-/gi, '/'))
  if (diffValue < 0) {
    return
  }
  var monthC = diffValue / month
  var weekC = diffValue / (7 * day)
  var dayC = diffValue / day
  var hourC = diffValue / hour
  var minC = diffValue / minute
  var result = ''
  if (monthC >= 1) {
    result = '' + parseInt(monthC) + '月前'
  } else if (weekC >= 1) {
    result = '' + parseInt(weekC) + '周前'
  } else if (dayC >= 1) {
    result = '' + parseInt(dayC) + '天前'
  } else if (hourC >= 1) {
    result = '' + parseInt(hourC) + '小时前'
  } else if (minC >= 1) {
    result = '' + parseInt(minC) + '分钟前'
  } else {
    result = '刚刚'
  }
  return result
}

export const clone = (sourcObj, targetObj, isClearTarget) => {
  if (targetObj === undefined) { // 未传第二个参数
    return cloneObj(sourcObj);
  }
  if (targetObj === null) {
    targetObj = {};
  }
  if (isClearTarget) { // 清楚原来对象的属性
    for (var k in targetObj) {
      delete targetObj[k];
    }
  }
  for (var j in sourcObj) {
    targetObj[j] = sourcObj[j];
  }
  return targetObj;
}

function cloneObj(obj) { // 等价于调用 clone(obj)
  var o, obj;
  if (obj.constructor == Object) {
    o = new obj.constructor();
  } else {
    o = new obj.constructor(obj.valueOf());
  }
  for (var key in obj) {
    if (o[key] != obj[key]) {
      if (typeof (obj[key]) == 'object') {
        o[key] = cloneObj(obj[key]);
      } else {
        o[key] = obj[key];
      }
    }
  }
  o.toString = obj.toString;
  o.valueOf = obj.valueOf;
  return o;
};

import * as axios from './axios'
import * as ajax from './ajax'
let param = {
  "table": "codemaster",
  "selectCols": "CodeMisc,CodeMiscName,CodeValue,CodeName,CodeValue value,CodeName name,CodeAlias, Value1, Value2, Value3, Value4, Priority, Remark",
  "where": "where ModifyState = '1'",
  "exparams": {}
}
let codeList = []
console.log("是否执行")
let codeListStr = localStorage.getItem('CODE_MASTER')
if (codeListStr) {
  codeList = JSON.parse(codeListStr)
} else {
  axios.post("getCodeMaster", param).then(rst => {
    if (rst.retCode === 0) {
      codeList = rst.retData
      localStorage.setItem('CODE_MASTER', JSON.stringify(codeList))
    } else {
      console.error(rst.retMsg)
    }
  })
}


let findCodeList = function (code) {
  var codes = codeList.filter(function (eachItem) {
    return eachItem.CodeMisc == code
  });
  return codes
}

// 查询医院列表
let test = []

export const findCodeHospitalList1 = function (code) {

  console.log("证明执行")

  let paramHospital = {
    "table": "hospital_info",
    "selectCols": "hospitalNo,hospitalName",
    "where": "",
    "exparams": {}
  }

  let codeHospitalList = []



  axios.post("hospital/getSelectList", paramHospital).then(rst => {
    if (rst.retCode === 0) {
      codeHospitalList = rst.retData
      console.log("打印查询到的医院列表："+codeHospitalList)

      var codes = codeHospitalList
      console.log("打印查询到的医院列表1："+codeHospitalList)

      console.log("打印codes："+codes)

      for(let key  in codes){
        console.log(key + '---' + codes[key])

        var c = codes[key]

        for(let key1  in c){
          console.log(key1 + '---' + c[key1])
        }

      }
      test = codes
      console.log("打印返回的codes："+codes)
    } else {
      console.error(rst.retMsg)
    }
  })

}

let findCodeHospitalList = async function () {

  let paramHospital = {
    "table": "hospital_info",
    "selectCols": "hospitalNo,hospitalName",
    "where": "",
    "exparams": {}
  }

  let codeHospitalList = []

   await axios.post("hospital/getSelectList", paramHospital).then(rst => {
    if (rst.retCode === 0) {
      codeHospitalList = rst.retData
      console.log("111打印查询到的医院列表："+codeHospitalList)

      var codes = codeHospitalList
      console.log("111打印查询到的医院列表1："+codeHospitalList)

      console.log("111打印codes："+codes)

      for(let key  in codes){
        console.log(key + '---' + codes[key])

        var c = codes[key]

        for(let key1  in c){
          console.log(key1 + '---' + c[key1])
        }

      }

      console.log("111打印返回的codes："+codes)

      Promise.all(codes).then(function(res){

        console.log("res======: "+res)

      })

      for(let key  in codes){
        console.log(key + '角色P111---' + codes[key])

        var c = codes[key]

        for(let key1  in c){
          console.log(key1 + '---' + c[key1])
        }

      }

      return codes
      // test = codes

    } else {
      console.error(rst.retMsg)
    }})

  // axios.post("hospital/getSelectList", paramHospital).then(
  // })

}

export const getCodeList = function (code) {
  let codes = []

  switch (code) {
    case 'sex':
      codes = findCodeList("IV001")
      break
    case 'type':
      codes = findCodeList("IV002")
      break
    case 'status':
      codes = findCodeList("IV003")
      break
    case 'purpose':
      codes = findCodeList("IV004")
      break
    case 'refuseText':
      codes = findCodeList("IV011")
      break
    case 'reviewStatus':
      codes = findCodeList("IV012")
      break
    case 'specialType':
      codes = findCodeList("IV010")
      break
    case 'hospital':
      console.log("执行switch")
      codes = findCodeHospitalList().then((res)=>{console.log("返回中的返回："+res)})
      console.log("返回的codes："+codes)
      codes = []
      // console.log("返回的codes："+codes.then((res)=>{console.log("返回中的返回："+res)}))
      break
    default:
      break
  }
  return codes
}
export const getCode = function (codeMisc, codeValue) {
  var codes = getCodeList(codeMisc).filter(function (eachItem) {
    //return eachItem.CodeValue == codeValue && eachItem.ModifyState == '1'
    return eachItem.CodeValue == codeValue
  });
  return codes[0]
}

let ConstList = [{
  "type": '001', // 管理角色
  "code": 0,
  "name": '科室审批成员'
}, 
{
  "type": '001',
  "code": 1,
  "name": '手术室审批成员'
}, {
  "type": '001',
  "code": 2,
  "name": '手术管理运行中心成员'
}]
let ConstSpaceList = [{
  "type": '',
  "code": '',
  "name": ''
}]

export const getConstList = function (type, withspace) {
  if (!(type))
    return []

  let codes = ConstList.filter(function (eachItem) {
    return eachItem.type == type
  });

  if (withspace && codes && codes.length > 0) {
    codes = ConstSpaceList.concat(codes)
  }

  // for(let key  in codes){
  //   console.log(key + '角色---' + codes[key])
  //
  //   var c = codes[key]
  //
  //   for(let key1  in c){
  //     console.log(key1 + '---' + c[key1])
  //   }
  //
  // }

  return codes
}

export const getConstName = function (type, code) {
  if (!(type))
    return ''

  var codes = ConstList.filter(function (eachItem) {
    return eachItem.type == type && eachItem.code == code
  });

  if (codes && codes.length == 1) {
    return codes[0].name
  }
  return ''
}

export const getCodeName = function (codeMisc, codeValue) {
  if (!(codeMisc && codeValue))
    return ''

  var codes = getCodeList(codeMisc).filter(function (eachItem) {
    return eachItem.CodeValue == codeValue
  });

  if (codes && codes.length == 1) {
    return codes[0].CodeName
  }
  return ''
}

export const getCodeNameByCodeMisc = function (codeMisc, codeValue) {
  if (!(codeMisc && codeValue))
    return ''

  var codes = findCodeList(codeMisc).filter(function (eachItem) {
    return eachItem.CodeValue == codeValue
  });

  if (codes && codes.length == 1) {
    return codes[0].CodeName
  }
  return ''
}

export const htmlEncode = function (text) {
  return text.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g,
    '&lt;').replace(/>/g, '&gt;');
}

export const trim = function (text) {
  if (typeof (text) == "string") {
    return text.replace(/^\s*|\s*$/g, "");
  } else {
    return text;
  }
}

export const isEmpty = function (val) {
  switch (typeof (val)) {
    case 'string':
      return trim(val).length == 0 ? true : false;
      break;
    case 'number':
      return val == 0;
      break;
    case 'object':
      return val == null;
      break;
    case 'array':
      return val.length == 0;
      break;
    default:
      return true;
  }
}

/**
 * 数字型检查
 * 例：
 * isNumber('')				 => false
 * isNumber('.')				 => false
 * isNumber('12.')			 => true
 * isNumber('123')			 => true
 * isNumber('0.1234')			 => true
 * isNumber('0.12345')		 => false 等价于 isNumber('0.12345',4) 小数位超出4
 * isNumber('123.1234',4,6)	 => false 总长度为7,超过指定的最大长度6
 *
 * @param val 待检查的数字,必须指定
 * @param maxDigit 小数部分最大位数,不指定时默认为4位;-1,表示不限制
 * @param maxTotalLen 整个数字最大长度(含小数部分数字,但不含小数点),不指定时默认为20位;-1,表示不限制
 */
export const isNumber = function (val, maxDigit, maxTotalLen) {
  if (maxDigit === undefined) {
    maxDigit = 4; //默认最多4位小数
  }
  if (maxTotalLen === undefined) {
    maxTotalLen = 20; //默认总长度最多20位(含小数位)
  }
  var maxIntLen = maxTotalLen - maxDigit; //整数部分位数
  if (maxTotalLen > 0 && maxIntLen <= 0) {
    console.log('总长度不能小于0');
    //报错
  }
  //var reg = /^[\d|\.|,]+$/;
  //var reg = new RegExp('^\\d{1,'+maxIntLen+'}(\\.\\d{0,'+maxDigit+'})?$');
  var reg = new RegExp('^\\d' + (maxTotalLen <= 0 ? '+' : '{1,' + maxIntLen + '}') + '(\\.\\d' + (maxDigit < 0 ? '*' : '{0,' + maxDigit + '}') + ')?$');

  return reg.test(val);
}

export const isInt = function (val) {
  if (val == "") {
    return false;
  }
  var reg = /\D+/;
  return !reg.test(val);
}

/**
 * 数字值最小值check
 * @param val 被check的值
 * @param min 参考的最小值
 * @return 如果被check的值小于min返回false,否则返回true
 */
export const checkMin = function (val, min) {
  return Number(val) >= min;
}

/**
 * 数字值最大值check
 * @param val 被check的值
 * @param max 参考的最大值
 * @return 如果被check的值大于max返回false,否则返回true
 */
export const checkMax = function (val, max) {
  return Number(val) <= max;
}

/**
 * 最小长度位check
 * @param val 被check的值
 * @param minLength 参考的最小长度
 * @return 如果被check的值长度小于min返回false,否则返回true
 */
export const checkMinLength = function (val, minLength) {
  return String(val).length >= minLength;
}

/**
 * 最大长度位check
 * @param val 被check的值
 * @param maxLength 参考的最大长度
 * @return 如果被check的值长度小于min返回false,否则返回true
 */
export const checkMaxLength = function (val, maxLength) {
  return String(val).length <= maxLength;
}


export const isEmail = function (email) {
  var reg1 = /([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)/;

  return reg1.test(email);
}

export const isTel = function (tel) {
  var reg = /^[\d|\-|\s|\_]+$/; // 只允许使用数字-空格等

  return reg.test(tel);
}

export const fixEvent = function (e) {
  var evt = (typeof e == "undefined") ? window.event : e;
  return evt;
}

export const srcElement = function (e) {
  if (typeof e == "undefined")
    e = window.event;
  var src = document.all ? e.srcElement : e.target;

  return src;
}

export const isTime = function (val) {
  var reg = /^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}$/;

  return reg.test(val);
}

export const Fadd = function (a, b) {
  var c, d, e;
  try {
    c = a.toString().split(".")[1].length;
  } catch (f) {
    c = 0;
  }
  try {
    d = b.toString().split(".")[1].length;
  } catch (f) {
    d = 0;
  }
  return e = Math.pow(10, Math.max(c, d)), (Fmul(a, e) + Fmul(b, e)) / e;
}

export const Fsub = function (a, b) {
  var c, d, e;
  try {
    c = a.toString().split(".")[1].length;
  } catch (f) {
    c = 0;
  }
  try {
    d = b.toString().split(".")[1].length;
  } catch (f) {
    d = 0;
  }
  return e = Math.pow(10, Math.max(c, d)), (Fmul(a, e) - Fmul(b, e)) / e;
}

export const Fmul = function (a, b) {
  var c = 0,
    d = a.toString(),
    e = b.toString();
  try {
    c += d.split(".")[1].length;
  } catch (f) {}
  try {
    c += e.split(".")[1].length;
  } catch (f) {}
  return Number(d.replace(".", "")) * Number(e.replace(".", "")) / Math.pow(10, c);
}

export const Fdiv = function (a, b) {
  var c, d, e = 0,
    f = 0;
  try {
    e = a.toString().split(".")[1].length;
  } catch (g) {}
  try {
    f = b.toString().split(".")[1].length;
  } catch (g) {}
  return c = Number(a.toString().replace(".", "")), d = Number(b.toString().replace(".", "")), Fmul(c / d, Math.pow(10, f - e));
}

//json对象key值首字母小写化
export const  toLowerCaseObjKey = function(jsonObj) {
    if(typeof(jsonObj)=='object'){
         for (var key in jsonObj){
              let val = jsonObj[key]
              delete(jsonObj[key])
              jsonObj[key.substring(0,1).toLowerCase()+key.substring(1)] = val
          }
    }
    return jsonObj
}



// WEBPACK FOOTER //
// ./src/untils/common.js